import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { useCallback } from 'react';

/** Actions available on the logger stream selection menu. */
export type SelectionMenuAction =
  | 'play'
  | 'pause'
  | 'create_fragment'
  | 'copy_quick_share'
  | 'add_chunk'
  | 'clear';

/** Which selection menu variant fired the event. */
export type SelectionMenuMode = 'default' | 'editor';

export interface SelectionMenuCaptureProps {
  action: SelectionMenuAction;
  mode: SelectionMenuMode;
  /** Selection length in ms when both ends are set. */
  duration_ms?: number;
}

/**
 * PostHog capture for selection menu clicks.
 * Events are sent as `logger:selection_menu_action` with action, mode, and optional duration.
 */
export function useSelectionMenuCapture() {
  const capture = usePostHogCapture({ domain: 'logger' });

  return useCallback(
    ({ action, mode, duration_ms }: SelectionMenuCaptureProps) => {
      capture('selection_menu_action', {
        action,
        mode,
        ...(duration_ms != null ? { duration_ms } : {}),
      });
    },
    [capture],
  );
}
